module.exports = __webpack_public_path__ + "img/13n@2x.67d63a14.svg";